// extracted by mini-css-extract-plugin
module.exports = {"bodyWrapper":"Body_bodyWrapper__2Lcxa","detailsWrapper":"Body_detailsWrapper__2a1kJ"};